export const ADDITIONAL_MINORS_FIELD_NAMES = {
  expectingMinorsType: 'expectingMinorsType',
  pregnancy: 'pregnancy',
  pregnancyCount: 'pregnancyCount',
  pregnancyDueDate: 'pregnancyDueDate',
  adoption: 'adoption',
  adoptionCount: 'adoptionCount',
  anticipatedAdoptionDate: 'anticipatedAdoptionDate',
  guardianship: 'guardianship',
  guardianshipCount: 'guardianshipCount',
  anticipatedGuardianshipStartDate: 'anticipatedGuardianshipStartDate',
  notApplicable: 'notApplicable',
};
